import React, { useState, useEffect } from "react";
import {
  DownOutlined,
  IssuesCloseOutlined,
  StarFilled,
} from "@ant-design/icons";
import { Badge, Empty, Button, List, Dropdown, Menu } from "antd";
import { PropTypes } from "prop-types";
import { useTranslation } from "react-i18next";
import {
  regionLocale,
  precisionDecimal,
} from "../../common/InputNumberFormatter";
import dayjs from "dayjs";

export default function PendingApprovalClaimWidget({
  isLoading,
  pendingClaimsApproval,
  history,
}) {
  const { t } = useTranslation();
  const [hasPendingApproval, setHasPendingApproval] = useState(false);

  const menu = (
    <Menu
      onClick={handleMenuClick}
      items={[
        {
          label: t("pendingApprovalClaimWidget.claim_approval"),
          key: "1",
        },
        {
          label: t("pendingApprovalClaimWidget.claim_cancellation"),
          key: "2",
        },
      ]}
    ></Menu>
  );

  function onView() {
    const approveClaim = pendingClaimsApproval.claimsInfo.filter(
      (x) => x.Status === 1 || x.Status === 4
    );
    const cancelClaim = pendingClaimsApproval.claimsInfo.filter(
      (x) => x.Status !== 1 && x.Status !== 4
    );

    if (approveClaim.length > 0) {
      const minYear = Math.min(...approveClaim.map((item) => item.Year));
      history("/home/claimsubmissionapproval", {
        state: {
          year: minYear,
        },
      });
    } else {
      const minYear = Math.min(...cancelClaim.map((item) => item.Year));
      history("/home/claimcancellationapproval", {
        state: {
          year: minYear,
        },
      });
    }
  }

  function handleMenuClick(e) {
    const approveClaim = pendingClaimsApproval.claimsInfo.filter(
      (x) => x.Status === 1 || x.Status === 4
    );
    const cancelClaim = pendingClaimsApproval.claimsInfo.filter(
      (x) => x.Status !== 1 && x.Status !== 4
    );

    if (e.key === "1") {
      const minYear = Math.min(...approveClaim.map((item) => item.Year));
      history("/home/claimsubmissionapproval", {
        state: {
          year: minYear,
        },
      });
    } else {
      const minYear = Math.min(...cancelClaim.map((item) => item.Year));
      history("/home/claimcancellationapproval", {
        state: {
          year: minYear,
        },
      });
    }
  }

  useEffect(() => {
    setHasPendingApproval(pendingClaimsApproval.pendingAmount > 0);
  }, [pendingClaimsApproval]);

  return (
    <div style={{ display: !isLoading ? "block" : "none" }}>
      <div style={{ textAlign: "center", margin: "10px auto" }}>
        <Badge
          className="dashboard-badge"
          count={
            <StarFilled
              style={
                hasPendingApproval
                  ? { display: "none" }
                  : { color: "rgba(245, 171, 53, 1)" }
              }
            />
          }
        >
          <div className="pending-number-second">
            {pendingClaimsApproval.pendingAmount}
          </div>
        </Badge>
      </div>
      <div
        style={
          hasPendingApproval
            ? {
                marginTop: "15px",
                height: "195px",
                backgroundColor: "#f5f7fa",
                borderRadius: "10px",
                overflow: "auto",
              }
            : { display: "none" }
        }
      >
        <List
          itemLayout="horizontal"
          dataSource={pendingClaimsApproval.claimsInfo}
          renderItem={(item) => (
            <List.Item>
              <List.Item.Meta
                style={{ padding: "0 0 0 10px" }}
                title={item.EmpyName}
                description={item.ClaimTypeDesc}
              />
              <div style={{ padding: "0 10px 0 0", textAlign: "right" }}>
                {item.FuncCurrSymb + " "}
                {item.FuncTotalAmount.toLocaleString(regionLocale(), {
                  minimumFractionDigits: precisionDecimal(item.FuncCurrCode),
                  maximumFractionDigits: 2,
                })}
                <br />
                {dayjs(item.TransDate).format("DD/MM/YYYY")}
              </div>
            </List.Item>
          )}
        />
      </div>
      <div
        style={
          hasPendingApproval ? { display: "none" } : { padding: "10px 0 10px" }
        }
      >
        <Empty
          image="https://gw.alipayobjects.com/mdn/miniapp_social/afts/img/A*pevERLJC9v0AAAAAAAAAAABjAQAAAQ/original"
          imageStyle={{
            height: 60,
            display: "none",
          }}
          description={
            <span>
              {t("pendingApprovalClaimWidget.no_more_pending_request")}
            </span>
          }
        ></Empty>
      </div>
      <div className="dashboard-card-button" style={{ textAlign: "right" }}>
        <Button
          type="primary"
          icon={<IssuesCloseOutlined />}
          onClick={() => onView && onView()}
          style={{
            display: !pendingClaimsApproval.isMixStatus ? "" : "none",
          }}
        >
          {t("pendingApprovalClaimWidget.view_request")}
        </Button>

        <Dropdown
          dropdownRender={() => menu}
          style={{
            display: pendingClaimsApproval.isMixStatus ? "" : "none",
          }}
        >
          <Button
            type="primary"
            icon={<IssuesCloseOutlined />}
            style={{
              display: pendingClaimsApproval.isMixStatus ? "" : "none",
            }}
          >
            {t("pendingApprovalClaimWidget.view_request")} <DownOutlined />
          </Button>
        </Dropdown>
      </div>
    </div>
  );
}

PendingApprovalClaimWidget.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  pendingClaimsApproval: PropTypes.object.isRequired,
  history: PropTypes.func.isRequired,
};
